"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseDefinedContext = void 0;
const react_1 = require("react");
/**
 * useContext always return defined value. Otherwise it throws an error.
 * @param context the context to use in a hook
 * @param errorMessage the message of error thrown in case of context was not found in react tree.
 */
const createUseDefinedContext = (context, errorMessage) => () => {
    const contextValue = (0, react_1.useContext)(context);
    if (contextValue === undefined) {
        throw new Error(errorMessage);
    }
    return contextValue;
};
exports.createUseDefinedContext = createUseDefinedContext;
//# sourceMappingURL=createUseDefinedContext.js.map